class Onlynumber {
    constructor(opts){
        this.opts = $.extend({
            el:"#element",
        }, opts);

        this.$el = $(this.opts.el);

        this.init();
    }

    init(){
        this.controls();
    }

    controls(){
        this.$el.on("keydown", (event)=>{
            return this.onlyNumber(event);
        });

        this.$el.on("keyup", (event)=>{
            this.removeChar(event);
        });
    };

    onlyNumber(event){
        let keyId = event.which;
        if ( (keyId >= 48 && keyId <= 57) || (keyId >= 96 && keyId <= 105) || keyId == 8 || keyId == 46 || keyId == 37 || keyId == 39 ){
            return;
        }else{
            return false;
        }
    };

    removeChar(event) {
        let keyId = event.which;
        if ( keyId == 8 || keyId == 46 || keyId == 37 || keyId == 39 ){
            return;
        }else{
            event.target.value = event.target.value.replace(/[^0-9]/g, "");
        };


    };
}

export default Onlynumber;


// WEBPACK FOOTER //
// ./src/js/util/onlynumber.js